module.exports = __webpack_public_path__ + "img/filled_circle.33b4bd79.svg";